module.exports = __webpack_public_path__ + "img/papakava_web_logo 1.3852150e.png";